import { programLabels } from '@/config';
import { getManufacturerByProgram } from '@/libs/util';

import { copaySupport } from './support/copay';

const CopaySupport = ({ name }: { name: string }) => {
  const info = copaySupport[name.toLowerCase() as keyof typeof copaySupport];

  if (!info) return null;

  return (
    <div className="mx-auto py-10">
      <div className="text-xl md:text-3xl font-bold text-[#000000]">{info.name}</div>

      <div className="mt-10 text-2xl font-bold">{info.title}</div>

      <p className="my-2">{info.description}</p>

      {info.copayInfo && (
        <ul className="list-disc ml-6">
          {info.copayInfo.items.map((item, index) => (
            <li className="my-2" key={index}>
              {item.label}
            </li>
          ))}
        </ul>
      )}

      <div className="mt-8 font-bold">{info.eligibilityCriteria.title}</div>

      <ul className="list-disc ml-6">
        {info.eligibilityCriteria.items.map((item, index) => (
          <li className="my-2" key={index}>
            {item.label}
          </li>
        ))}
      </ul>

      {'note' in info.eligibilityCriteria && info.eligibilityCriteria.note && (
        <p className="mt-4">{info.eligibilityCriteria.note}</p>
      )}

      <div className="mt-8 font-bold">{info.restrictions.title}</div>

      <ul className="list-disc ml-6">
        {info.restrictions.items.map((item, index) => (
          <li className="my-2" key={index}>
            {item.label}
          </li>
        ))}
      </ul>

      <div className="mt-8 text-2xl font-bold">{info.reimbursementSupport.title}</div>

      <p className="my-2">{info.reimbursementSupport.description}</p>

      {'freeTrial' in info && info.freeTrial && (
        <>
          <div className="mt-8 font-bold">{info.freeTrial.title}</div>
          <p className="my-2">{info.freeTrial.description}</p>
          <ul className="list-disc ml-6">
            {info.freeTrial.items.map((item, index) => (
              <li className="my-2" key={index}>
                {item.label}
              </li>
            ))}
          </ul>
        </>
      )}

      <div className="mt-6">
        This program is subject to change or discontinuation by&nbsp;
        <b>{getManufacturerByProgram(name)}</b>
        &nbsp;at any time, for any reason, and with or without prior notice. This portal is
        administered by&nbsp;
        <a
          target="_blank"
          href="https://medmonk.com/"
          className="text-sky-700 hover:underline"
          rel="noopener noreferrer"
        >
          Medmonk
        </a>
        &nbsp;for The {programLabels[name as keyof typeof programLabels]?.label} Program.
      </div>

      {'additionalResources' in info && info.additionalResources && (
        <>
          <div className="mt-8 text-2xl font-bold">{info.additionalResources.title}</div>
          <p className="my-2">{info.additionalResources.description}</p>
        </>
      )}
    </div>
  );
};

export default CopaySupport;
